import { render, staticRenderFns } from "./CRUDFamiliasAtendimento.vue?vue&type=template&id=9b3be172&"
import script from "./CRUDFamiliasAtendimento.vue?vue&type=script&lang=js&"
export * from "./CRUDFamiliasAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports